import { render } from "./AssignUsersModalSingleUser.vue?vue&type=template&id=71b14f2a&scoped=true"
import script from "./AssignUsersModalSingleUser.vue?vue&type=script&lang=js"
export * from "./AssignUsersModalSingleUser.vue?vue&type=script&lang=js"

import "./AssignUsersModalSingleUser.vue?vue&type=style&index=0&id=71b14f2a&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b14f2a"]])

export default __exports__